import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { faqs, WA_DEFAULT } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-panel/30 border-y hairline scroll-mt-20" aria-label="Frequently asked questions">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-28">
          <SectionHeading
            eyebrow="FAQ"
            lines={[<>Questions,</>, <>answered <em className="italic text-brand">honestly.</em></>]}
          />
          <Reveal delay={0.2}>
            <p className="mt-6 text-mute text-sm sm:text-base leading-relaxed max-w-sm">
              Still unsure about something? Message us directly — we reply fast, usually within the hour.
            </p>
            <a
              data-testid="faq-ask-button"
              href={WA_DEFAULT}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-6 inline-flex items-center gap-3 pl-6 pr-1.5 py-1.5 border border-brand/60 text-white text-sm font-semibold hover:bg-brand/5 transition-colors duration-300"
            >
              Ask on WhatsApp
              <span className="btn-arrow-box"><ArrowUpRight size={15} /></span>
            </a>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-b hairline">
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-display font-medium text-lg sm:text-xl text-white hover:text-brand hover:no-underline transition-colors duration-300 [&[data-state=open]>svg]:text-brand"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`} className="text-mute text-sm sm:text-base leading-relaxed pr-8">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);
